import styled from "styled-components";
//components
import Text from "components/Text";
import { Button } from "components/Button";
import { Row } from "components/Layout/Grid";


export const ButtonRow = styled(Row)`
  width: 100%;
  justify-content: center;
`;

export const CustomButton = styled(Button)`
  width: 340px;
  margin-top: 16px;
  background-color: #0E4C54;
`;

export const CustomButtonText = styled(Text)`
  color: #FFFFFF;
  font-weight: bold;
  padding-right: 1.2em;
`;

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing:border-box;
  min-height: 100px;

  > div {
      &:first-child > div > div {
        border-top: none;
      }
    }
`;